import { useQuery } from "react-query";
import { getAlarmType } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useAlarmType = () => {
  const { data, isLoading, refetch } = useQuery("GetAlarmType", getAlarmType, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
